import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import JobForm from "@/components/JobForm";

export default function JobDialog({ open, onOpenChange, job }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto" data-testid="job-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">{job?.id ? "Edit Job" : "New Job"}</DialogTitle>
          <DialogDescription>Fill in the drone job details and save to the shared calendar.</DialogDescription>
        </DialogHeader>
        <JobForm initial={job} onSaved={() => onOpenChange(false)} onClose={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
